import { REGEX } from "../constants";

export const formatPhone = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, "");

  // Special handling for 11-digit numbers starting with 1
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    const digits = cleaned.slice(-10);
    return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
      6
    )}`;
  }

  if (!REGEX.phone.test(phone)) {
    return phone;
  }

  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6
    )}`;
  }

  return phone;
};
